<script setup lang="ts">
import { watch, ref, reactive, shallowRef } from 'vue';
import { useRoute } from 'vue-router';
import ProjectIcon from '@/assets/images/icons8-box-35-black.svg?component';
import PartIcon from '@/assets/images/icons8-puzzle-35-black.svg?component';
import LightIcon from '@/assets/images/icons8-light-automation-35-black.svg?component';
import PerspectiveIcon from '@/assets/images/icons8-binoculars-35-black.svg?component';
import HotspotIcon from '@/assets/images/icons8-goal-35-black.svg?component';
import CustomPropIcon from '@/assets/images/icons8-support-35-black.svg?component';

import type { Component, ShallowRef } from 'vue';

interface IIconRoute {
  to: string;
  icon: ShallowRef<Component>;
  label: string;
}

const route = useRoute();
const activeRoute = ref(route.path);

const routes = reactive<IIconRoute[]>([
  { to: '/', icon: shallowRef(ProjectIcon), label: 'Project' },
  { to: '/parts', icon: shallowRef(PartIcon), label: 'Parts' },
  { to: '/lighting', icon: shallowRef(LightIcon), label: 'Lighting' },
  { to: '/perspectives', icon: shallowRef(PerspectiveIcon), label: 'Perspectives' },
  { to: '/hotspots', icon: shallowRef(HotspotIcon), label: 'Hotspots' },
  { to: '/custom', icon: shallowRef(CustomPropIcon), label: 'Custom' },
]);

const routePathWatcher = (route: string) => {
  if (routes.find((singleRoute) => singleRoute.to === route)) {
    activeRoute.value = route;
  } else {
    activeRoute.value = '/';
  }
};

watch(() => route.path, routePathWatcher);
</script>

<template>
  <nav class="flex flex-col w-full text-center">
    <router-link
      v-for="iconRoute in routes"
      :key="iconRoute.label"
      :to="iconRoute.to"
      :title="iconRoute.label"
      class="flex flex-col items-center py-1 last-of-type:mb-0 border-b last-of-type:border-b-0 rounded-sm"
      :class="{
        'bg-white': activeRoute !== iconRoute.to,
        'bg-slate-300': activeRoute === iconRoute.to,
      }"
    >
      <component :is="iconRoute.icon" />
      <span class="text-xs mt-1">{{ iconRoute.label }}</span>
    </router-link>
  </nav>
</template>
